/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

// suggest code improvements for this component
// give the entire code to copy
// ran this thru claudes code refactoring tool
// ran this thru claudes design


import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { FaGoogle } from "react-icons/fa6";
import { FaFacebook, FaUser } from "react-icons/fa";
import { IoMdLogIn } from "react-icons/io";
import { FiEye, FiEyeOff } from "react-icons/fi";

import { customer_register, messageClear } from '../store/reducers/authReducer';
import { newsletterSubscriber_register } from '../store/reducers/newsletterSubscriberReducer';
import { FadeLoader } from 'react-spinners';

import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { formatPhoneNumber } from 'react-phone-number-input'

import Header from '../components/Header';
import Footer from '../components/Footer';
import GetSellerConfig from '../components/GetSellerConfig';

import toast from 'react-hot-toast';
import config from '../config';
import SiteBadge from '../components/SiteBadge';

const Register = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;
    const sellerDashbordURL = config.STR_DASHBOARD_URL;
    const sellerArrMessagingPreferences = config.STR_ARR_MESSAGING_PREFERENCES;

    //const { seller } = useSelector(state => state.seller);
    const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);
    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerShopName, sellerStripePaymentMode, sellerOtherWebsiteURL1, sellerOtherWebsiteName1, 
        sellerOtherWebsiteURL2, sellerOtherWebsiteName2, sellerProductTerm, sellerProductPluralTerm,
        sellerCompanyPhoneNumber, sellerCompanyLogo,sellerSellerImage, sellerBeforeYouRegister1, sellerPhoneNumber,
        sellerCompanyEmailAddress, sellerCompanyKosherSupervision1, 
        sellerCompanyKosherSupervision2, sellerMainIngredientPluralTerm, sellerTaglineTop1, sellerTaglineTop2, 
        personalServiceTagLine, sellerMarketingLine1, sellerHolidayHeader, sellerOwnerNames,
        sellerBoolShowSiteWishList, sellerBoolShowSiteChat, sellerBoolShowGalleryImages, sellerBoolShowSocialMedia
    } = GetSellerConfig();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [state, setState] = useState({
        webSiteOrigin: sellerFrontendURL,
        name: '',
        eventName: '',
        eventDate: '',
        email: '',
        password: '',
        messagingPreferences: JSON.stringify(sellerArrMessagingPreferences)
    });

    const [myPhoneNumber, setMyPhoneNumber] = useState('');
    const [isNewsletterSignUpChecked, setNewsletterSignUpIsChecked] = useState(true);
    const [showPassword, setShowPassword] = useState(false);

    const handleNewsletterSignUpCheckboxChange = (event) => {
        setNewsletterSignUpIsChecked(event.target.checked);
    };

    const inputHandle = (e) => {
        setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const customer_register_local = (e) => {
        e.preventDefault();
        const submissionData = {
            ...state,
            phoneNumber: myPhoneNumber,
            newsletterSignUp: isNewsletterSignUpChecked
        };
        dispatch(customer_register(submissionData));
        if (isNewsletterSignUpChecked) {
            const arrNames = state.name.split(' ');
            dispatch(newsletterSubscriber_register({
                webSiteOrigin: sellerFrontendURL,
                firstName: arrNames[0],
                lastName: arrNames[1] || '',
                email: state.email,
                isSubscribed: true
            }));
        }
    };

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
        if (userInfo) {
            navigate('/');
        }
    }, [successMessage, errorMessage, userInfo]);

    return (
        <div className="flex flex-col min-h-screen">
            {/* Loading overlay */}
            {loader && (
                <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-black/20 backdrop-blur-sm z-[999]">
                    <FadeLoader />
                </div>
            )}
            <Header />
            {/* Page background */}
            <main className="flex-1 flex items-center justify-center px-4 py-8"
                style={{ backgroundColor: sellerComponentBackgroundColor }}>
                <div className="w-full max-w-md">
                    {/* Card */}
                    <div
                        className="bg-white rounded-2xl shadow-xl overflow-hidden"
                        style={{ 
                            borderTop: `4px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                            borderBottom: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,  
                            borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                            borderRight: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                         }}>
                        <div className="px-8 pt-8 pb-10">
                            {/* Header */}
                            <div className="flex items-center justify-center justify-items-center mb-4 text-left">
                                <div
                                    className="inline-flex items-center justify-center w-14 h-14 rounded-xl mb-0 mr-2">
                                    <SiteBadge iconType='Register' iconSize={38} badgeSize={54} />
                                </div>
                                <div>
                                    <span className='leading-tight text-right font-semibold text-[20px] sm:text-[16px]' 
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        {
                                            <>Create Your Account<br /><span className='font-bold' style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                                                It Is Nice To See You
                                            </span></>
                                        }
                                    </span>
                                </div>
                            </div>
                                                        
                            <div>
                                {sellerBeforeYouRegister1 && (
                                    <p className="mt-0 text-sm text-slate-500 leading-relaxed text-center"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        {sellerBeforeYouRegister1} 
                                        <span className='font-semibold ml-1'>
                                            <span className='hidden sm:inline'><br /></span>
                                            {formatPhoneNumber(sellerPhoneNumber)}
                                        </span>
                                    </p>
                                )}
                            </div>
                            
                            {/* Form */}
                            <form onSubmit={customer_register_local} className="space-y-4">

                                {/* Name */}
                                <div className="flex flex-col gap-1.5">
                                    <label
                                        htmlFor="name"
                                        className="text-xs font-semibold uppercase tracking-widest"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        Full Name
                                    </label>
                                    <input
                                        required
                                        onChange={inputHandle}
                                        value={state.name}
                                        type="text"
                                        name="name"
                                        placeholder="Jane Smith"
                                        id="name"
                                        className="w-full px-4 py-2.5 text-sm text-slate-700 bg-slate-50 border border-slate-200 rounded-lg outline-none focus:ring-2 focus:ring-offset-1 transition-all duration-200 placeholder:text-slate-400"
                                        style={{ '--tw-ring-color': sellerPrimaryColor1 + sellerColorSuffixDark }}
                                    />
                                </div>

                                {/* Event Name */}
                                <div className="flex flex-col gap-1.5">
                                    <label
                                        htmlFor="eventName"
                                        className="text-xs font-semibold uppercase tracking-widest"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        Event Name
                                    </label>
                                    <input
                                        onChange={inputHandle}
                                        value={state.eventName}
                                        type="text"
                                        name="eventName"
                                        id="eventName"
                                        placeholder="My Special Event"
                                        className="w-full px-4 py-2.5 text-sm text-slate-700 bg-slate-50 border border-slate-200 rounded-lg outline-none focus:ring-2 focus:ring-offset-1 transition-all duration-200 placeholder:text-slate-400"
                                    />
                                </div>

                                {/* Event Date */}
                                <div className="flex flex-col gap-1.5">
                                    <label
                                        htmlFor="eventDate"
                                        className="text-xs font-semibold uppercase tracking-widest"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                    >
                                        Event Date
                                    </label>
                                    <input
                                        onChange={inputHandle}
                                        value={state.eventDate}
                                        type="date"
                                        name="eventDate"
                                        id="eventDate"
                                        className="w-full px-4 py-2.5 text-sm text-slate-700 bg-slate-50 border border-slate-200 rounded-lg outline-none focus:ring-2 focus:ring-offset-1 transition-all duration-200"
                                    />
                                </div>

                                {/* Phone */}
                                <div className="flex flex-col gap-1.5">
                                    <label
                                        htmlFor="phoneNumber"
                                        className="text-xs font-semibold uppercase tracking-widest"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                    >
                                        Phone Number
                                    </label>
                                    <div className="w-full px-4 py-2 bg-slate-50 border border-slate-200 rounded-lg focus-within:ring-2 focus-within:ring-offset-1 transition-all duration-200">
                                        <PhoneInput
                                            required
                                            defaultCountry="US"
                                            value={myPhoneNumber}
                                            onChange={setMyPhoneNumber}
                                            className="text-sm text-slate-700"
                                        />
                                    </div>
                                </div>

                                {/* Email */}
                                <div className="flex flex-col gap-1.5">
                                    <label
                                        htmlFor="email"
                                        className="text-xs font-semibold uppercase tracking-widest"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                    >
                                        Email Address
                                    </label>
                                    <input
                                        required
                                        onChange={inputHandle}
                                        value={state.email}
                                        type="email"
                                        name="email"
                                        placeholder="you@example.com"
                                        id="email"
                                        className="w-full px-4 py-2.5 text-sm text-slate-700 bg-slate-50 border border-slate-200 rounded-lg outline-none focus:ring-2 focus:ring-offset-1 transition-all duration-200 placeholder:text-slate-400"
                                    />
                                </div>

                                {/* Password */}
                                <div className="flex flex-col gap-1.5">
                                    <label
                                        htmlFor="password"
                                        className="text-xs font-semibold uppercase tracking-widest"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                    >
                                        Password
                                    </label>
                                    <div className="relative flex items-center">
                                        <input
                                            onChange={inputHandle}
                                            value={state.password}
                                            className="w-full px-3.5 py-2.5 pr-10 text-sm text-gray-900 placeholder-gray-400 bg-white border border-gray-200 rounded-lg outline-none transition-all duration-150 focus:border-gray-400 focus:ring-2 focus:ring-gray-100"
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            placeholder="••••••••"
                                            id="password"
                                            required
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(prev => !prev)}
                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                                        >
                                            {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                                        </button>
                                    </div>
                                </div>

                                {/* Newsletter checkbox 
                                    <input
                                        required
                                        onChange={inputHandle}
                                        value={state.password}
                                        type="password"
                                        name="password"
                                        placeholder="••••••••"
                                        id="password"
                                        className="w-full px-4 py-2.5 text-sm text-slate-700 bg-slate-50 border border-slate-200 rounded-lg outline-none focus:ring-2 focus:ring-offset-1 transition-all duration-200 placeholder:text-slate-400"
                                    />
                                    
                                    
                                    */}
                                <div className="flex items-center gap-3 py-1">
                                    <input
                                        onChange={handleNewsletterSignUpCheckboxChange}
                                        checked={isNewsletterSignUpChecked}
                                        type="checkbox"
                                        name="newsletterSignUp"
                                        id="newsletterSignUp"
                                        className="w-4 h-4 rounded border-slate-300 cursor-pointer accent-current"
                                        style={{ accentColor: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                    />
                                    <label
                                        htmlFor="newsletterSignUp"
                                        className="text-sm text-slate-600 cursor-pointer select-none"
                                    >
                                        Keep me in the loop with the newsletter
                                    </label>
                                </div>

                                {/* Primary CTA */}
                                <button
                                    type="submit"
                                    className="flex w-full items-center justify-center gap-2 py-3 text-md font-semibold tracking-wide text-white rounded-lg shadow-md hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 transition-all duration-200"
                                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                    <FaUser size={20} />
                                    Create My Account
                                </button>

                                {/* Sign in link */}
                                <p className="text-center text-sm text-slate-500">
                                    Already have an account?{' '}
                                    <Link
                                        to="/login"
                                        className="font-semibold hover:underline underline-offset-2 transition-colors"
                                        style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                        Sign In
                                    </Link>
                                </p>

                                {/* Divider */}
                                <div className="flex items-center gap-3 py-1">
                                    <hr className="flex-1 border-slate-400" />
                                    <span className="text-xs text-slate-600 uppercase tracking-widest">Sellers</span>
                                    <hr className="flex-1 border-slate-400" />
                                </div>

                                {/* Seller buttons */}
                                <div className="flex flex-col gap-2.5">
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={`${sellerDashbordURL}/login`}
                                        className="flex w-full items-center justify-center gap-2 py-2.5 text-md font-medium 
                                        text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg hover:bg-emerald-100 
                                        hover:-translate-y-0.5 hover:shadow-sm transition-all duration-200">
                                        <IoMdLogIn size={24} />
                                        Sign In as a Seller
                                    </a>
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href={`${sellerDashbordURL}/register`}
                                        className="flex w-full items-center justify-center gap-2 py-2.5 text-md font-medium 
                                        text-violet-700 bg-violet-50 border border-violet-200 rounded-lg hover:bg-violet-100 
                                        hover:-translate-y-0.5 hover:shadow-sm transition-all duration-200">
                                        <FaUser size={20} />
                                        Register as a Seller
                                    </a>
                                </div>

                                {/* Social (hidden — preserved as-is) */}
                                <div className="hidden justify-center items-center gap-3">
                                    <div className="w-[135px] h-[35px] flex rounded-md bg-orange-700 shadow-lg hover:shadow-orange-700/50 justify-center cursor-pointer items-center overflow-hidden">
                                        <span><FaGoogle /></span>
                                    </div>
                                    <div className="w-[135px] h-[35px] flex rounded-md bg-blue-700 shadow-lg hover:shadow-blue-700/50 justify-center cursor-pointer items-center overflow-hidden">
                                        <span><FaFacebook /></span>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>

                    {/* Footer note */}
                    <p className="text-center text-xs text-slate-400 mt-5">
                        By registering, you agree to our Terms &amp; Privacy Policy.
                    </p>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Register;



//original code
// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaGoogle } from "react-icons/fa6";
// import { FaFacebook, FaUser } from "react-icons/fa";
// import { IoMdLogIn } from "react-icons/io";

// import { customer_register, messageClear } from '../store/reducers/authReducer';
// import { newsletterSubscriber_register } from '../store/reducers/newsletterSubscriberReducer';
// import { FadeLoader } from 'react-spinners';
// import 'react-phone-number-input/style.css';
// import PhoneInput from 'react-phone-number-input';

// import Header from '../components/Header';
// import Footer from '../components/Footer';

// import toast from 'react-hot-toast';
// import config from '../config';

// const Register = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;
//     const sellerDashbordURL = config.STR_DASHBOARD_URL;
//     const sellerArrMessagingPreferences = config.STR_ARR_MESSAGING_PREFERENCES;

//     const { seller } = useSelector(state => state.seller);
//     const { loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth);

//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1;
//     const sellerBeforeYouRegister1 = seller.beforeYouRegister1;

//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const [state, setState] = useState({
//         webSiteOrigin: sellerFrontendURL,
//         name: '',
//         eventName: '',
//         eventDate: '',
//         email: '',
//         password: '',
//         messagingPreferences: JSON.stringify(sellerArrMessagingPreferences)
//     });

//     const [myPhoneNumber, setMyPhoneNumber] = useState('');
//     const [isNewsletterSignUpChecked, setNewsletterSignUpIsChecked] = useState(true);

//     const handleNewsletterSignUpCheckboxChange = (event) => {
//         setNewsletterSignUpIsChecked(event.target.checked);
//     };

//     const inputHandle = (e) => {
//         setState(prev => ({
//             ...prev,
//             [e.target.name]: e.target.value
//         }));
//     };

//     const customer_register_local = (e) => {
//         e.preventDefault();

//         // Fix: use setState instead of directly mutating state
//         const submissionData = {
//             ...state,
//             phoneNumber: myPhoneNumber,
//             newsletterSignUp: isNewsletterSignUpChecked
//         };

//         dispatch(customer_register(submissionData));

//         // Note: ideally this should only fire on successful registration
//         // You can move this into the useEffect when successMessage is received
//         if (isNewsletterSignUpChecked) {
//             const arrNames = state.name.split(' ');
//             dispatch(newsletterSubscriber_register({
//                 webSiteOrigin: sellerFrontendURL,
//                 firstName: arrNames[0],
//                 lastName: arrNames[1] || '',
//                 email: state.email,
//                 isSubscribed: true
//             }));
//         }
//     };

//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             dispatch(messageClear());
//         }
//         if (userInfo) {
//             navigate('/');
//         }
//     }, [successMessage, errorMessage, userInfo]); // Fix: added userInfo to deps

//     return (
//         <div>
//             {loader &&
//                 <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]'>
//                     <FadeLoader />
//                 </div>
//             }
//             <Header />
//             <div className='min-w-screen bg-slate-200 flex justify-center items-center'>
//                 <div className='w-[350px] p-2 m-4'>
//                     <div className='bg-white p-4 rounded-md shadow-lg'>
//                         <div className='flex gap-0.5 justify-center items-center text-center text-xl font-bold' style={{ color: sellerPrimaryColor1 }}>
//                             <FaUser size={16} /> Register
//                         </div>
//                         <div className='text-center text-md mt-1' style={{ color: sellerPrimaryColor1 }}>
//                             {sellerBeforeYouRegister1}
//                         </div>
//                         <form onSubmit={customer_register_local}>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="name">Name</label>
//                                 <input required onChange={inputHandle} value={state.name} type="text" name='name' placeholder='Name' id='name'
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md'
//                                     style={{ color: sellerPrimaryColor1 }} />
//                             </div>
//                             <div className='flex flex-col gap-1 mb-2' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="eventName">Event Name (Short)</label>
//                                 <input onChange={inputHandle} value={state.eventName} type="text" name="eventName" id="eventName" placeholder='Event Name'
//                                     className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                             </div>
//                             <div className='flex flex-col gap-1 mb-2' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="eventDate">Event Date</label>
//                                 <input onChange={inputHandle} value={state.eventDate} type="date" name="eventDate" id="eventDate"
//                                     className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                             </div>
//                             <div className='flex flex-col gap-1 mb-2' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="phoneNumber">Phone Number</label>
//                                 <PhoneInput required defaultCountry='US' value={myPhoneNumber} onChange={setMyPhoneNumber}
//                                     className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                             </div>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="email">Email</label>
//                                 <input required onChange={inputHandle} value={state.email} type="email" name='email' placeholder='Email' id='email'
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md' />
//                             </div>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="password">Password</label>
//                                 <input required onChange={inputHandle} value={state.password} type="password" name='password' placeholder='Password' id='password'
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md' />
//                             </div>
//                             <div className='flex items-center w-full gap-3 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <input onChange={handleNewsletterSignUpCheckboxChange} checked={isNewsletterSignUpChecked}
//                                     className='w-4 h-4 text-blue-600 bg-gray-200 rounded border-gray-300 focus:ring-blue-500'
//                                     type="checkbox" name="newsletterSignUp" id="newsletterSignUp" />
//                                 <label htmlFor="newsletterSignUp">Sign Me Up For The Newsletter</label>
//                             </div>
//                             <button
//                                 type="submit"
//                                 className='flex px-8 w-full mb-2 py-2 text-center justify-center items-center gap-2 text-white rounded-md'
//                                 style={{ backgroundColor: sellerPrimaryColor1 }}>
//                                 <FaUser size={16} /> Create My Account
//                             </button>
//                             <div className='flex items-center mb-3 gap-3 justify-center' style={{ color: sellerPrimaryColor1 }}>
//                                 <div>
//                                     Already Have An Account?&nbsp;
//                                     <Link className='font-bold' to="/login">Sign In</Link>
//                                 </div>
//                             </div>
//                             <a target='_blank' rel='noreferrer' href={`${sellerDashbordURL}/login`}>
//                                 <div className='flex px-8 w-full py-2 bg-green-700 text-white rounded-md justify-center items-center gap-0.5 mb-3'>
//                                     <IoMdLogIn size={20} /> Login As a Seller
//                                 </div>
//                             </a>
//                             <a target='_blank' rel='noreferrer' href={`${sellerDashbordURL}/register`}>
//                                 <div className='flex px-8 w-full py-2 bg-purple-700 text-white rounded-md justify-center items-center gap-2 mb-3'>
//                                     <FaUser /> Register As a Seller
//                                 </div>
//                             </a>
//                             <div className='hidden justify-center items-center gap-3'>
//                                 <div className='w-[135px] h-[35px] flex rounded-md bg-orange-700 shadow-lg hover:shadow-orange-700/50 justify-center cursor-pointer items-center overflow-hidden'>
//                                     <span><FaGoogle /></span>
//                                 </div>
//                                 <div className='w-[135px] h-[35px] flex rounded-md bg-blue-700 shadow-lg hover:shadow-blue-700/50 justify-center cursor-pointer items-center overflow-hidden'>
//                                     <span><FaFacebook /></span>
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default Register;





//my original code
// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { FaFacebookF, FaGoogle } from "react-icons/fa6";
// import { FaFacebook, FaUser, FaUserCheck } from "react-icons/fa";
// import { IoMdLogIn } from "react-icons/io";

// import { customer_register, messageClear } from '../store/reducers/authReducer';
// import { newsletterSubscriber_register } from '../store/reducers/newsletterSubscriberReducer'
// import { FadeLoader } from 'react-spinners';
// import 'react-phone-number-input/style.css'
// import PhoneInput from 'react-phone-number-input'

// import Header from '../components/Header';
// import Footer from '../components/Footer';

// import toast from 'react-hot-toast';
// import config from '../config';

// const Register = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL
//     const sellerDashbordURL  = config.STR_DASHBOARD_URL
//     const sellerArrMessagingPreferences = config.STR_ARR_MESSAGING_PREFERENCES

//     const { seller } = useSelector(state => state.seller)
//     const {loader, errorMessage, successMessage, userInfo } = useSelector(state => state.auth)
        
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
//     const sellerBeforeYouRegister1 = seller.beforeYouRegister1

//     const navigate = useNavigate()
//     const dispatch = useDispatch()

//     let [state, setState] = useState({
//         webSiteOrigin: sellerFrontendURL, 
//         name: '',  
//         eventName: '', 
//         eventDate: '', 
//         phoneNumber:'', 
//         email: '', 
//         password: '',
//         messagingPreferences: JSON.stringify(sellerArrMessagingPreferences)
//         //newsletterSignUp: true
//     })
    
//     const [myPhoneNumber, setMyPhoneNumber] = useState()
//     const [isNewsletterSignUpChecked, setNewsletterSignUpIsChecked] = useState(true);
//     const handleNewsletterSignUpCheckboxChange = (event) => {
//         setNewsletterSignUpIsChecked(event.target.checked);
//     };
//     const inputHandle = (e) => {
//         setState({
//             ...state,
//             [e.target.name]: e.target.value
//         })
//         //console.log(state)
//     }

//     const customer_register_local = (e) => {
//         e.preventDefault()
//         state.phoneNumber = myPhoneNumber
//         state.newsletterSignUp = isNewsletterSignUpChecked
//         //console.log(state)
//         dispatch(customer_register(state))

//         if (isNewsletterSignUpChecked){
//             let arrNames = state.name.split(' ')
//             dispatch(newsletterSubscriber_register({
//                 webSiteOrigin: sellerFrontendURL, 
//                 firstName: arrNames[0], 
//                 lastName: arrNames[1], 
//                 email: state.email, 
//                 isSubscribed: true
//             }))
//         }
//     }

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             dispatch(messageClear())  
//         } 
//         if (userInfo) {
//             navigate('/')
//         }
//     },[successMessage, errorMessage])

//     return (
//         <div>
//             {
//                 loader && 
//                 <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]'>
//                     <FadeLoader/>
//                 </div>
//             }
//             <Header/>
//             {/* register form  min-h-screen */}
//             <div className='min-w-screen bg-slate-200 flex justify-center items-center' >
//                 <div className='w-[350px] p-2 m-4'>
//                     <div className='bg-white text-[#ffffff] p-4 rounded-md shadow-lg'>
//                         <div className='flex gap-0.5 justify-center items-center text-center text-xl font-bold' style={{ color: sellerPrimaryColor1 }}>
//                             <FaUser size={16} /> Register
//                         </div>
//                         <div className='text-center text-md mt-1' style={{ color: sellerPrimaryColor1 }}>
//                             {sellerBeforeYouRegister1}
//                         </div>
//                         <form onSubmit={customer_register_local}>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="name">Name</label>
//                                 <input required onChange={inputHandle} value={state.name} type="text" name='name' placeholder='Name' id='name'  
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md' 
//                                      style={{ color: sellerPrimaryColor1 }} />
//                             </div>  
//                             <div className='flex flex-col gap-1 mb-2' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="eventName">Event Name (Short)</label>
//                                 <input onChange={inputHandle} value={state.eventName} type="text" name="eventName" id="eventName" placeholder='Event Name' 
//                                     className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                             </div>
//                             <div className='flex flex-col gap-1 mb-2' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="eventDate">Event Date</label>
//                                 <input onChange={inputHandle} value={state.eventDate} type="date" name="eventDate" id="eventDate" 
//                                     className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                             </div>
//                             <div className='flex flex-col gap-1 mb-2' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="phoneNumber">Phone Number</label>
//                                 <PhoneInput required defaultCountry='US' country="US" value={myPhoneNumber} onChange={setMyPhoneNumber} 
//                                     className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                             </div>
//                             {
//                                 //         // <input onChange={inputHandle} value={state.phoneNumber} type="tel" name="phoneNumber" id="phoneNumber" placeholder='Phone Number' 
//                                 //         // className='hidden w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
                                
//                                 //         // <PhoneInput defaultCountry='US' country="US" value={phoneNumber} onChange={setPhoneNumber}
//                                 //         // className='w-full px-3 py-2 border border-slate-200 outline-none focus:border-green-500 rounded-md' />
//                                 //         //<PhoneInput country="US" value={phoneNumber} onChange={setPhoneNumber} />
                                    
//                                 // </div>
//                             }
//                             <span className='hidden'>placeholder:text-[#6a5fdf] bg-[#bed0f5] text-[#6a5fdf]</span>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="email">Email</label>
//                                 <input required onChange={inputHandle} value={state.email} type="email" name='email' placeholder='Email' id='email'  
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md' />
//                             </div>
//                             <div className='flex flex-col w-full gap-1 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <label htmlFor="password">Password</label>
//                                 <input required onChange={inputHandle} value={state.password} type="password" name='password' placeholder='Password' id='password' 
//                                     className='px-3 py-2 outline-none border border-slate-400 bg-transparent rounded-md' />
//                             </div>
//                             <div className='flex items-center w-full gap-3 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <input onChange={handleNewsletterSignUpCheckboxChange} checked={isNewsletterSignUpChecked} 
//                                     className='w-4 h-4 text-blue-600 overflow-hidden bg-gray-200 rounded border-gray-300 focus:ring-blue-500' 
//                                     type="checkbox" name="newsletterSignUp" id="newsletterSignUp" />
//                                 <label htmlFor="checkbox"> Sign Me Up For The Newsletter</label> 
//                             </div>
//                             <div className='flex items-center w-full gap-3 mb-3' style={{ color: sellerPrimaryColor1 }}>
//                                 <input className='hidden w-4 h-4 text-blue-600 overflow-hidden bg-gray-200 rounded border-gray-300 focus:ring-blue-500' 
//                                     type="checkbox" name="checkbox" id="checkbox" />
//                                 <label className='hidden' htmlFor="checkbox"> I agree to privacy policy & terms</label> 
//                             </div>
//                             <button className='flex px-8 w-full mb-2 mr-2 py-2 text-center justify-center items-center gap-2 text-white rounded-md' 
//                                 style={{backgroundColor:sellerPrimaryColor1}}>
//                                 <FaUser size={16} /> Create My Account
//                             </button>
//                             <div className='flex items-center mb-3 gap-3 justify-center' style={{ color: sellerPrimaryColor1 }}>
//                                 <div>
//                                     Already Have An Account ? 
//                                     <Link className='font-bold' to="/login">Sign In</Link>
//                                 </div>
//                             </div>
//                             <a target='_blank' href={`${sellerDashbordURL}/login`}>
//                                 <div className='flex px-8 w-full py-2 bg-green-700 text-white rounded-md justify-center items-center gap-0.5 mb-3'>
//                                     <IoMdLogIn size={20} /> Login As a Seller
//                                 </div>
//                             </a>
//                             {/* bg-[#ad2cc4] bg-[#02e3e0]*/}
//                             <a target='_blank' href={`${sellerDashbordURL}/register`}>
//                                 <div className='flex px-8 w-full py-2 bg-purple-700 text-white rounded-md justify-center items-center gap-2 mb-3'>
//                                     <FaUser /> Register As a Seller
//                                 </div>
//                             </a>
//                             <div className='hidden justify-center items-center gap-3'>
//                                 <div className='w-[135px] h-[35px] flex rounded-md bg-orange-700 shadow-lg hover:shadow-orange-700/50 justify-center cursor-pointer items-center overflow-hidden'>
//                                     <span><FaGoogle /></span>
//                                 </div>
//                                 <div className='w-[135px] h-[35px] flex rounded-md bg-blue-700 shadow-lg hover:shadow-blue-700/50 justify-center cursor-pointer items-center overflow-hidden'>
//                                     <span><FaFacebook /></span>
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                 </div>  
//             </div>
//             <Footer/>
//         </div>
//     );
// };

// export default Register;




